import {createRootContextHook} from 'common/util/react';

export const useQueryContextManager = createRootContextHook(`queryContextManager`);
